
import { loggingConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';
import { Toaster } from 'components/notification/Toaster';



export const loggingActions = {
	getLogs,
}

function getLogs(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
		}

		let url = func_serviceHandling.createUrlWithParams('/General/GetActivityLog', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get logs";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: loggingConstants.getLogs_request, details }; }
    function success(details) { return { type: loggingConstants.getLogs_success, details }; }
    function failure(error) { return { type: loggingConstants.getLogs_failure, error }; }
}